import GeorgeRansom from "assets/images/psp/review-george.png";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import SMurphy from "assets/images/psp/review-murphy.png";
import Related1 from "assets/images/psp/relatedContentImages/related-college-1.webp";
import Related2 from "assets/images/psp/relatedContentImages/related-college-2.webp";
import Related3 from "assets/images/psp/relatedContentImages/related-college-3.webp";
import HeaderBackgroundDesktop from "assets/images/psp/hero/college-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/college-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/college-header-tablet.webp";
import { storageCategories } from "pages/PSPPage/utils/getPSPLinks";

const reviews = {
	title: "Storage.com has a 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: 'Great experience with my storage! I love the "drive right in" climate-controlled storage area. Staff was super helpful with telling me about the system they use and setting me up.',
			author: "Jachooz",
			title: "Great experience with my storage",
			imageSrc: GeorgeRansom
		},
		{
			body: "Very knowledgeable and detail-oriented. The storage facility the Storage.com rep recommended is very close to where I live and at a reasonable rate. Climate-controlled and state-of-the-art security, which I can appreciate. Thanks again for all of your help and information.",
			author: "C. Meredith",
			title: "Excellent Customer Service",
			imageSrc: SMurphy
		},
		{
			body: "Abby, the customer service representative at storage.com, was professional, helpful and friendly. She found me a storage space at an excellent price in close proximity to my home. I can't thank her enough.",
			author: "Ann Alarcon",
			title: "A wonderful experience",
			imageSrc: AnnAlarcon
		}
	]
};

const faqs = [
	{
		question: "How much does student storage cost for summer break?",
		answer: "According to Storage.com's 2025 national averages, college student storage units cost $44.81 monthly for 5x5 units and $63.05 monthly for 5x10 units—enough space for one complete dorm room. For a 3-month summer break, expect to pay approximately $134-$189 total."
	},
	{
		question: "Can multiple students share one storage unit?",
		answer: "Yes, many facilities allow shared rentals. A 10x10 unit at Storage.com's average price of $97.40, split between three roommates, costs each student only $32.47 monthly—making it cheaper than even the smallest individual units."
	},
	{
		question: "When should I reserve a storage unit for summer?",
		answer: "Book storage units 3-4 weeks before finals end. Facilities near universities fill quickly during peak moving season (late April through May). Early reservations often include better rates than the national averages."
	},
	{
		question: "Do I need climate control for college storage?",
		answer: "Climate control isn't necessary for most items like furniture, clothes, and kitchen supplies. Climate-controlled small units cost $35-$60 monthly—consider it for electronics, important documents, or musical instruments stored during hot/humid summers."
	},
	{
		question: "Can I access my storage unit during summer break?",
		answer: "Absolutely. Most storage unit university locations offer daily access during business hours, and some provide 24/7 access codes so you can retrieve items anytime during break without additional fees."
	},
	{
		question: "What items shouldn't go in student storage?",
		answer: "Perishable food, plants, hazardous materials, and anything illegal. Empty your mini fridge and prop the door open to prevent mold during the storage period."
	},
	{
		question: "Is insurance necessary for student storage?",
		answer: "Basic renter's insurance often covers belongings in storage. Check your policy or your parents' homeowners insurance before purchasing facility insurance, which typically costs $10-$20 monthly, adding 20-45% to the base storage cost."
	},
	{
		question: "What's the cheapest way to store dorm room items?",
		answer: "The most affordable option is splitting a 10x10 unit ($97.40/month average) with 2-3 roommates, bringing individual costs down to $32-$49 monthly. For solo students, a 5x5 unit at $44.81/month offers the best value."
	}
];

const relatedContentCards = [
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/self-storage-for-college-students/",
		date: "July 24, 2025",
		image: Related1,
		content: "7 Ways to Use Self-Storage for College Students"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/4-quick-tips-for-college-self-storage/",
		date: "July 30, 2025",
		image: Related2,
		content:
			"Smart Storage Solutions for College Students: Find Your Perfect Fit"
	},
	{
		category: "Self Storage",
		url: "https://blog.storage.com/what-to-expect-when-renting-storage-unit/",
		date: "May 22, 2025",
		image: Related3,
		content: "7 Things to Expect When You Rent a Storage Unit"
	}
];

const collegeHerodescription = `
College students face an impossible task every semester break: Stuffing their entire academic life into a cramped car, and making it disappear for weeks to months at a time, only to retrieve and reorganize everything in a weekend when school begins again. Storage units for students solve this by providing affordable, temporary storage right near campus. Storage.com connects college students with verified storage facilities near universities nationwide, offering flexible month-to-month options and student-friendly pricing.
`;

export const PSPCollegeContent = {
	type: "College",
	sections: [
		{
    title: "College Storage hero",
    noPadding: true,
    modules: [
        {
            type: "hero-section",
            props: {
                title: "Find the Top College Storage Units",
                description: collegeHerodescription,
                searchPlaceholder: "Search by city, state, or zip...",
                buttonText: "Find College Student Storage",
				heroImages: {
					desktop: HeaderBackgroundDesktop,
					tablet: HeaderBackgroundTablet,
					mobile: HeaderBackgroundMobile
				},
				heroAltText: "College Storage Hero Image"
            }
        }
    ]
},

		{
			title: "College content module",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "Do You Need College Student Storage?",
						background: "white",
						content: [
							{
								id: "1",
								value: "Every college student knows this stress: Finals week ends, you have 48 hours to vacate your dorm, and you're facing a 12-hour drive home with a sedan full of stuff. Shipping costs hundreds, your apartment lease doesn't start until August, and your parents' garage can't accommodate dorm room overflow."
							},
							{
								id: "2",
								value: "Student storage units are specifically designed for this challenge, with pricing that fits college budgets. Nationwide pricing on small storage units for college students averages $44.81 per month, while larger units will cost $63.05 per month. This is significantly cheaper than shipping boxes back and forth."
							},
							{
								id: "3",
								value:
									"If you need the following, then college student storage is right for you:\n" +
									"- Flexible rental periods\n" +
									"- [Ability to share a unit with roommates](https://www.storage.com/blog/save-money-sharing-storage-unit/)\n" +
									"- Convenient locations close to campus or home"
							}
						],
						isColumnWise: false
					}
				}
			]
		},
		{
			title: "College Storage Size Comparison",
			noPadding: true,
			modules: [
				{
					type: "size-comparison",
					props: {
						title: "Storage Units for Students: What Size is Right?",
						description:
							"Small units are a perfect choice for most students, but there’s a college student storage unit size for every need. Some are even large enough to share with your roommate or friends on campus! From small standard units to large [climate controlled units](https://www.storage.com/blog/climate-controlled-storage-units/) - we’ve got you covered.",

						sizes: [
							{
								id: "5x5",
								label: "5x5",
								title: "5' Wide x 5' Long",
									description:
									    "- Small unit size\n- **Best For:** Single student, essentials only\n- **Fits:** Mini fridge, 10-15 small boxes, compact furniture pieces like lamps"
							},
							{
								id: "5x10",
								label: "5x10",
								title: "5' Wide x 10' Long",
								description:
									"* Medium unit size\n*  **Best For:** Full dorm room contents, one student\n*  **Fits:** Bed, desk, dresser, fridge, 20-30 boxes"
							},
							{
								id: "10x10",
								label: "10x10",
								title: "10' Wide x 10' Long",
								description:
									"* Large unit size\n*  **Best For:** Shared storage, multiple roommates\n*  **Fits:** 2-3 dorm rooms worth, apartment furniture"
							},
							{
								id: "10x15",
								label: "10x15",
								title: "10' Wide x 15' Long",
								description:
									"* Large unit size\n*  **Best For:** Apartment furniture, group storage\n*  **Fits:** Multiple students sharing, full apartment contents"
							},
							{
								id: "Climate-Controlled",
								label: "Climate-Controlled",
								title: "Climate-Controlled",
								description:
									" - Varies in size \n" +
									" - Electronics, documents, instruments "
									
							}
						]
					}
				}
			]
		},
		{
			title: "College Storage Content section two",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "Who Needs Student Storage Units?",
						background: "white",
						description: "College storage isn't just for summer break. Here's how different students benefit from storage solutions:",
						content: [
							{
								id: "1",
								value: 
										"- **Out-of-State Students**  \nAvoid cross-country moves every semester, store belongings during winter break, and eliminate shipping costs for heavy items.\n"+
										 "- **Study Abroad Participants**  \nSemester or year-long storage while overseas, maintain apartment belongings during travel, and avoid lease-breaking costs.\n"+
										 "- **Graduating Seniors**  \nBridge the gap between graduation and first apartment, store belongings during post-grad travel, temporary solution before career relocation.\n"+
										 "- **Greek Life Members**  \nChapter house transitions, summer storage for shared items, sorority/fraternity event materials\n"+
										 "- **Athletes & Performers**  \nEquipment storage during off-season, musical instrument protection, specialized gear that doesn't fit dorm rooms"
							},
						]
					}
				}
			]
		},
		{
			title: "College Storage Content section three",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "7 Benefits of College Storage",
						background: "light-blue",
						description: "Student storage facilities near universities understand college timelines and budgets:\n",
						content: [
							{
								id: "1",
								value:
									"1. **Flexible Lease Terms:**  Month-to-month rentals without long-term commitments, perfect for semester schedules\n" +
									"2. **Student Discounts:**  Many facilities offer 10-20% discounts with a valid college ID, potentially reducing Storage.com's average prices even further\n" +
									"3. **Move-In Specials:**  First month free or reduced rates during peak moving seasons (May-June, August)\n" +
									"4. **Shared Unit Options:**  Some facilities allow verified students to split larger units and costs—a 10x10 unit at $97.40 split three ways costs each student only $32.47 monthly\n" +
									"5. **Convenient Locations:**  Facilities located near campus with easy access during move-in/move-out weeks\n" +
									"6. **Extended Access Hours:**  Understanding that students often move on weekends and evenings\n" +
									"7. **Truck Rental Partnerships:**  Discounted van or truck rentals to help with moving day"
							}
						]
					}
				}
			]
		},
		{
			title: "College Storage",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "College"
					}
				}
			]
		},
		{
			title: "College Customer Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: reviews
				}
			]
		},
		{
			title: "College Storage FAQs",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "College Storage FAQs",
						faqs
					}
				}
			]
		},
		{
			title: "College Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About College Storage",
						unitCards: relatedContentCards
					}
				}
			]
		},
		{
			title: "College Links to other PSP",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						background: "white",
						storageGridContent: {
							title: "More Ways to Store",
							storageTypes: storageCategories.collegeStudent
						}
					}
				}
			]
		},
		{
			title: "College Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						pageType: "PSP",
						background: "light-blue"
					}
				}
			]
		}
	]
};

export default PSPCollegeContent;
